export default {
    new_account_required_message: 'Due to the implementation of a new booking system, please create a new account.<br/>An account created before 07.04.2025 will not work in the new version of the system.',
    new_account_required_message_2: 'NOTE: If you wish, you can also book a ride without creating an account.',
    new_account_required_confirmation: 'I understand, do not show again',
    general_error: 'An error occurred, please try again later',
    followme_title: 'Follow me!',
    lang_pl: 'PL',
    lang_en: 'EN',
    lang_de: 'DE',
    date: 'Date',
    loading: 'Loading',
    send: 'Submit',
    baggage_hand: 'Hand luggage up to 5 kg',
    baggage_register: 'Checked baggage up to 25 kg',
    book_and_payment: 'Book and pay',
    book: 'Book',
    delete: 'Delete',
    back: 'Back',
    select: 'Select',
    net: 'net',
    gross: 'gross',
    piece: 'piece',
    vehicle: 'Vehicle',
    cancel: 'Cancel',
    ok: 'OK',
    email_example: 'for example email@page.com',
    departure: 'Departure',
    return: 'Return',
    departure_date: 'Departure date',
    departure_time: 'Departure hour',
    return_date: 'Return date',
    return_time: 'Return time',
    date_pick: 'Pick date',
    from: 'From',
    to: 'To',
    passenger: 'Passenger',
    passengers: 'Passengers',
    passengers_amount: 'Number of passengers',
    adults: 'Adults',
    kids: 'Kids',
    child_age_3: 'Kids 3 or under',
    purchaser_details: 'Purchaser\'s contact details',
    invoice: 'Invoice',
    payment_method: 'Payment method',
    order_error: 'Error placing the order',
    home_title: 'Follow me! online booking',

    first_name: 'First name',
    last_name: 'Last name',
    email: 'E-mail',
    phone_number: 'Phone number',
    street: 'Street',
    building_number: 'Building number',
    apartment_number: 'Apartment number',
    airport: 'Airport',
    zip: 'Zip code',
    flight_number: 'Flight number',
    comment: 'Comments',
    vat_number: 'Tax Identification Number',
    address: 'Address',
    post_code: 'Post Code',
    city: 'City',
    country: 'Country',
    company_name: 'Company name',
    age: 'Age',

    price: 'Price',
    total: 'Total',

    admin_panel: 'Admin panel',

    no_transfers_found: 'No transfers found',

    no_transfers_found_ask_by_email: 'If you did not find your requested transfer, please ask us by e-mail: <a href="mailto:{email}">{email}</a>.',

    at_ber_outdated_travel: 'From April 28 2022 journeys to the BER airport (Berlin Brandenburg) and from the BER airport (Berlin Brandenburg) are carried out by the Flixbus (buses and drivers of Follow me!). You can make a reservation at <a href="https://flixbus.pl/" target="_blank">flixbus.pl</a>.',

    at_ber_outdated_travel_2: 'If you don\'t find a convenient connection, please try our new service: BERBUS - ridesharing by door-to-door option to the Berlin Airport.',

    next: 'Next',

    field_is_required: 'Field {field} is required',

    datetime_has_to_be_in_the_future: 'Field {field} has to be in the future',
    datetime_has_to_be_in_2_days_from_now: 'Too short time until departure – booking is possible at least 48 hours before the start of the journey',
    time_has_to_be_later_than: 'Field {field} has to be time after {field_parent}',
    time_invalid: 'Field {field} is incomplete.',
    phone_has_to_start_with_plus: 'Phone number has to contain dialing code starting with + sign',

    data_updated_success: 'Data has been updated successfully',

    maintenance_long_wait_info: 'Order processing takes a long time?<br />Purchase your ticket at <a href="https://www.interglobus.pl/Default.aspx?language=en">interglobus.pl</a>',

    user_data: {
        header: 'My data',
        name: 'Name and surname',
        phone: 'Phone number',
        submit: 'Save',
    },

    auth: {
        session_expired: 'Session expired, please log in again to continue.',
        activate_account_here: 'Activate your account here:',
        activate_account_here_link: 'Activation',
        required_fields_info: 'Required fields',
        confirm_registration: 'Confirm account registration',
        activation_code: 'Activation code',
        confirm: 'Confirm',
        confirm_resend: 'Didn\'t receive the code?',
        confirm_resend_submit: 'Resend code',
        confirm_success: 'The account has been activated, you can now log in.',
        confirm_resend_back: 'Back',
        confirm_resend_success: 'Code resent, check your inbox.',
        login_failed: 'Invalid e-mail address or password.',
        login_success: 'Successfully logged in',
        register_success: 'Successfully registered. Confirm the registration by clicking on the link sent to the provided email address.',
        reset_password_success: 'A link to reset the password has been sent to the provided email address.',
        first_name: 'First name',
        last_name: 'Last name',
        login_header: 'Sign in',
        email: 'E-mail',
        email_address: 'E-mail Address',
        password: 'Password',
        confirm_password: 'Confirm password',
        forgot_password: 'Forgot Your Password?',
        password_match_warning: 'Passwords does not match',
        remember_me: 'Remember Me',
        submit: 'Sign in',
        login: 'Login',
        logout: 'Logout',
        register: 'Register',
        reset_password: {
            header: 'Reset Password',
            send_link_submit: 'Send link',
            submit: 'Change',
            password_changed: 'Password has been changed',
        },
        username: 'User name',
        personal_register: 'Personal Account',
        business_register: 'Business Account',
        activation_warning: 'Account will be active only after admin approval',
        profile: {
            invoice_info: 'Invoice data',
            company_name: 'Company name',
            address: 'Address',
            tax_number: 'Tax number',
            phone: 'Phone',
            post_code: 'Post code',
            city: 'City',
            country: 'Country',
        },
        countries: {
            POLAND: 'Poland',
            AUSTRIA: 'Austria',
            BELGIUM: 'Belgium',
            BULGARIA: 'Bulgaria',
            CROATIA: 'Croatia',
            REPUBLIC_OF_CYPRUS: 'Republic of Cyprus',
            CZECH_REPUBLIC: 'Czech Republic',
            DENMARK: 'Denmark',
            ESTONIA: 'Estonia',
            FINLAND: 'Finland',
            FRANCE: 'France',
            GERMANY: 'Germany',
            GREECE: 'Greece',
            HUNGARY: 'Hungary',
            IRELAND: 'Ireland',
            ITALY: 'Italy',
            LATVIA: 'Latvia',
            LITHUANIA: 'Lithuania',
            LUXEMBOURG: 'Luxembourg',
            MALTA: 'Malta',
            NETHERLANDS: 'Netherlands',
            PORTUGAL: 'Portugal',
            ROMANIA: 'Romania',
            SLOVAKIA: 'Slovakia',
            SLOVENIA: 'Slovenia',
            SPAIN: 'Spain',
            SWEDEN: 'Sweden',
        },
    },

    offer_types: {
        airport_transfers: 'Szczecin - Goleniów ✈️ - Szczecin',
        airport_transfers_card_title: 'Szczecin - Goleniów',
        business_taxi: 'Business Taxi',
        family_airport_taxi: 'Smart Taxi',
        coaches: 'Coaches',
        business_travel_management: 'Business Travel Management',
        bus_rental: 'Bus rental (without driver)',
        tours: 'Tours',
        berbus: 'BERBUS Szczecin - Berlin ✈️ - Szczecin',
        berbus_card_title: 'Szczecin - Berlin',
    },

    components: {
        phone_input: {
            format_hint: 'Format: +442072343456',
        },

        taxi_search_form: {
            from: 'From',
            to: 'To',
            search_no_results: 'Select an airport or enter an address, starting with the street name.',
            search_no_results2: 'If you have trouble finding it, contact us: <a href="mailto:{email}">{email}</a>.',
            date_pick: 'Pick a date',
            submit: 'Search',
            add_time: 'Add time',

            departure_date: 'Departure date',
            departure_time: 'Departure hour',
        },

        passengers: {
            quantity: 'none | One person | {count} people',
            quantity_adults: 'none | One adult | {count} adults',
            quantity_children: 'No children | One child | {count} children',
            quantity_label: 'Number of people',
            quantity_label_adults: 'Number of adults',
            quantity_label_children: 'Number of children',
            quantity_label_children_max_3: 'Number of children under 3',
        },
        coach_search_form: {
            from: 'Departure from',
            to: 'Arrival to',
            search_no_results: 'Enter the city name. If it is not found, please contact us by email.',
            date_pick: 'Pick a date',
            time_pick: 'Pick a time',
            departure_date: 'Departure date',
            departure_time: 'Departure time',
            return_date: 'Return date',
            return_time: 'Return time',
            submit: 'Next',
            word_from: 'from',
            progress_bar: {
                step1: 'Basic info',
                step2: 'Transfer type',
                step3: 'Additional options',
                step4: 'Contact form',
                step5: 'Summary',
            },
        },
    },

    taxi: {
        return_datetime: 'Return Date and time',
        return_date: 'Return Date',
        return_time: 'Return Time',
        provide_flight_time: 'Please enter the departure time',
        provide_flight_arrival_time: 'Please enter the arrival time',

        validation: {
            'return_date_required': 'Return date is required',
            'return_time_required': 'Return time is required',
            'at_least_one_passenger_required': 'You must select at least one passenger',
            'return_time_after_departure_time': 'Return date and time must be later',
        },

        components: {
            cart: {
                header: 'Your journey',

                no_travel: 'Select a vehicle to add it to your journey.',
                departure: 'Departure',
                return: 'Return',

                base_price: 'Base price',
                discount_value: 'Discount value',
                user_discount_value: 'User\'s discount',
            },

            progress: {
                search: 'Search',
                journey_select: 'Journey select',
                passengers_data: 'Passengers data',
                addresses: 'Addresses',
                additional_options: 'Additional options',
                summary_and_payment: 'Summary and payment',
            },
        },

        pages: {
            vehicles: {
                no_transfers_found: 'No transfers found',
                short_time: 'There are less than 48 hours left until your ride is scheduled. <br /> \n' +
                    'If you book during office hours (Mon-Fri 8:00 AM - 6:00 PM, Sat-Sun 10:00 AM - 6:00 PM), we will verify vehicle availability and confirm your booking within a few hours. <br /> \n' +
                    'If you book outside office hours, your booking will be verified the following day.',

                short_time_st: 'There are less than 36 hours left until your ride is scheduled. <br /> \n' +
                    'If you book during office hours (Mon-Fri 8:00 AM - 6:00 PM, Sat-Sun 10:00 AM - 6:00 PM), we will verify vehicle availability and confirm your booking within a few hours. <br /> \n' +
                    'If you book outside office hours, your booking will be verified the following day.',

                short_time_bt: 'There are less than 36 hours left until your ride is scheduled. <br /> \n' +
                    'If you book during office hours (Mon-Fri 8:00 AM - 6:00 PM, Sat-Sun 10:00 AM - 6:00 PM), we will verify vehicle availability and confirm your booking within a few hours. <br /> \n' +
                    'If you book outside office hours, your booking will be verified the following day.',

                eco_vehicle_confirmation: '<p>You have chosen the ECO {offerType} option, the passenger will be matched to your journey, thanks to which you will be able to take advantage of the most-attractive {offerType} offer.</p>' +
                    '<p>Important! In a situation where it will not be possible to connect your trip with another passenger, you will be able to use the trip at the regular {offerType} price (for an extra charge) or cancel the trip at no cost. You will receive all informations in the next email.</p>',
                price_includes: 'Price includes',
                prefer_info: 'Please be advised that if the selected car brand is not available, we will provide the service with another car of the same class.',
            },

            addresses: {
                header: 'Addresses',

                pickup_addresses: 'Pick-up address',
                destination_addresses: 'Destination address',

                return_travel: 'Return journey',

                return_pickup_addresses: 'Return travel: Pick-up address',
                return_destination_addresses: 'Return travel: Destination address',

                address_add: 'Add another address',
                address_remove_confirm: 'Are you sure you want to remove this address?',
                book_return: 'Book a return journey',

                submit: 'Proceed to additional options',

                return_not_possible: 'Our pricelist does not contain a return course for this trip, please contact us if you want to order a return trip: <a href="mailto:{email}">{email}</a>',

                pickup_address_info_title: 'Add another address',
                pickup_address_info_desc: '<p>If you want to add a third pickup address, enter it in the order comment. The cost of an additional pick-up location is PLN 9 gross.</p><p>This is a non-standard option, therefore the mentioned cost will not be included in the payment for this order. The amount due should be paid separately, based on the instructions sent by e-mail from the Follow me!</p>',
            },

            passengers: {
                'login_in_to_speed_up_process': 'Do you have an account? Log in to speed up the purchase process.',
                'passengers_data': 'Passengers data',
                'go_to_addresses': 'Go to addresses',
                'add_next_passenger_data': 'Add next passenger details',
            },

            options: {
                header: 'Additional options',

                comments: 'Additional options comments (optional)',

                submit: 'Proceed to summary',
            },

            summary: {
                header: 'Summary and payment',

                email_tooltip: 'We will send you the confirmation and tickets to this e-mail address.',
                phone_number_tooltip: 'Phone number is only used in emergency cases.',

                is_invoice: 'I would like an invoice',

                invoice: {
                    name: 'Name',
                },

                tos: 'By creating an order I hereby accept the {general} and the {privacy}.',
                tos_general: 'general transfer rules of Follow Me!',
                tos_privacy: 'privacy policy',

                consents_text: 'The reservation is considered made after paying for it and receiving confirmation by e-mail. In the absence of confirmation, please contact us.',

                submit: 'Pay now {amount}',
                submit_no_payment: 'Submit the order',

                creating_order: 'Creating order',
                creating_order_redirect: 'You will be redirect to the payment page in a moment',

                discount_codes: {
                    header: 'Discount codes',
                    submit: 'Use',
                },

                short_time_payment: 'We will send you the order confirmation with the payment link.',
                delayed_payment: 'Your account allows deferred payment.',
                create_user_account: 'Create a user account using the above data',

                payment_polcard: '[First Data Polcard] Payment by card / quick transfer',
                payment_ecard: 'Quick transfer / credit (debit) card / BLIK',
                payment_ecard_optional_info: 'Card payment method will be disabled at the end of September 2024',

                use_first_passenger_data: 'Use first passenger\'s data',
            },

            confirmation: {
                header: 'The order #{orderNumber}',

                bt: {
                    paid: '<p>Order No. {orderNumber} has been accepted.</p>' +
                        '<p>Order details have been sent to the e-mail address provided in the booking.</p>' +
                        '<p>IMPORTANT: if you are traveling to the airport, make sure you plan your trip with the right time. Remember that a safe arrival at the airport is min. 2h before departure.</p>' +
                        '<p>See you on board the Follow me!</p>',
                    paid_eco: '<p>Order No. {orderNumber} has been accepted.</p>' +
                        '<p>You have chosen the ECO Business Taxi option, the passenger will be matched to your journey, thanks to which you will be able to take advantage of the most attractive Business Taxi offer.</p>' +
                        '<p>Important! In a situation where it will not be possible to connect your trip with another passenger, you will be able to use the trip at the regular Business Taxi price (for an extra charge) or cancel the trip at no cost. You will receive all informations in the next email.</p>' +
                        '<p>If you do not receive the message, check the "Spam" folder or contact our helpline giving the order number.</p>',
                    short_time: '<p>Order No. {orderNumber} has been accepted.</p>' +
                        '<p>Due to the fact that less than 48 hours remain to your journey, it is necessary to verify vehicle availability. We will confirm your reservation within max. 2 hours.</p>' +
                        '<p>You will receive notification and further instructions to the e-mail address provided in the booking.</p>' +
                        '<p>If you don\'t receive the message, check the "Spam" folder or contact our helpline giving your order number.</p>',
                    deferred: '<p>Order No. {orderNumber} has been accepted.</p>' +
                        '<p>Order details have been sent to the e-mail address provided in the booking.</p>' +
                        '<p>IMPORTANT: if you are traveling to the airport, make sure you plan your trip with the right time. Remember that a safe arrival at the airport is min. 2h before departure.</p>' +
                        '<p>See you on board the Follow me!</p>',
                },
                fat: {
                    paid: '<p>Order No. {orderNumber} has been accepted.</p>' +
                        '<p>Order details have been sent to the e-mail address provided in the booking.</p>' +
                        '<p>IMPORTANT: if you are traveling to the airport, make sure you plan your trip with the right time. Remember that a safe arrival at the airport is min. 2h before departure.</p>' +
                        '<p>See you on board the Follow me!</p>',
                    paid_eco: '<p>Order No. {orderNumber} has been accepted.</p>' +
                        '<p>You have chosen the ECO Smart Taxi option, the passenger will be matched to your journey, thanks to which you will be able to take advantage of the most attractive Smart Taxi offer.</p>' +
                        '<p>Important! In a situation where it will not be possible to connect your trip with another passenger, you will be able to use the trip at the regular Smart Taxi price (for an extra charge) or cancel the trip at no cost. You will receive all informations in the next email.</p>' +
                        '<p>If you do not receive the message, check the "Spam" folder or contact our helpline giving the order number.</p>',
                    short_time: '<p>Order No. {orderNumber} has been accepted.</p>' +
                        '<p>Due to the fact that less than 48 hours remain to your journey, it is necessary to verify vehicle availability. We will confirm your reservation within max. 2 hours.</p>' +
                        '<p>You will receive notification and further instructions to the e-mail address provided in the booking.</p>' +
                        '<p>If you don\'t receive the message, check the "Spam" folder or contact our helpline giving your order number.</p>',
                    deferred: '<p>Order No. {orderNumber} has been accepted.</p>' +
                        '<p>Order details have been sent to the e-mail address provided in the booking.</p>' +
                        '<p>IMPORTANT: if you are traveling to the airport, make sure you plan your trip with the right time. Remember that a safe arrival at the airport is min. 2h before departure.</p>' +
                        '<p>See you on board the Follow me!</p>',
                },
                berbus: {
                    paid: `<p>Order No. {orderNumber} has been accepted.</p>
                        <p>Your booking has been paid, a detailed summary of the order was sent to the e-mail address you've provided. Because a shared BERBUS ride has been selected, the exact hour at which you will be picked up from the provided address will be sent to you in a separate e-mail message. This information will be sent to you 24 hours before the trip at latest.</p>
                        <p>IMPORTANT: If you are traveling to an airport, make sure you've planned your trip with enough spare time. Remember: a safe time buffer is at least 2 hours before the flight's departure.</p>
                        <p>See you on board Follow me!</p>`,
                    paid_eco: `<p>Order No. {orderNumber} has been accepted.</p>
                        <p>Your booking has been paid, a detailed summary of the order was sent to the e-mail address you've provided. Because a shared BERBUS ride has been selected, the exact hour at which you will be picked up from the provided address will be sent to you in a separate e-mail message. This information will be sent to you 24 hours before the trip at latest.</p>
                        <p>IMPORTANT: If you are traveling to an airport, make sure you've planned your trip with enough spare time. Remember: a safe time buffer is at least 2 hours before the flight's departure.</p>
                        <p>See you on board Follow me!</p>`,
                    short_time: `<p>Order No. {orderNumber} has been accepted.</p>
                        <p>Since there are 48 hours or less before your trip, additional verification of the booking's availability is necessary.</p>
                        <p>We will confirm your booking within 2 hours. The message and further instructions will be sent to your via e-mail to the address from the booking.</p>
                        <p>Should you not receive the message, please make sure to check your "Spam" folder or contact our helpline directly with your order's number.</p>`,
                    deferred: `<p>Order No. {orderNumber} has been accepted.</p>
                        <p>A detailed summary of the order was sent to the e-mail address you've provided.</p>
                        <p>IMPORTANT: If you are traveling to an airport, make sure you've planned your trip with enough spare time. Remember: a safe time buffer is at least 2 hours before the flight's departure.</p>
                        <p>See you on board Follow me!</p>`,
                },
            },

            payment_error: {
                header: 'Payment declined.',
                details: 'Payment has been declined.',
            },
        },
    },

    airport_transfers: {
        components: {
            search_form: {
                from: 'From',
                to: 'To',
                search_no_results: 'Enter the city name. If it is not found, please contact us by email: <a href="mailto:{email}">{email}</a>.',
                date_pick: 'Pick a date',
                submit: 'Search',
                one_way: 'One way',
            },
            progress_header: {
                step1: 'Basic information',
                step2: 'Departures',
                step3: 'Returns',
                step4: 'Passengers information',
                step5: 'Additional options',
                step6: 'Summary',
            },
        },
        pages: {
            lowest_price: 'Lowest prices of the day',
            all_transfers: 'All transfers',
            select: 'Pick',
            cart: {
                your_travel: 'Your travel',
                empty_message: 'Pick an option to add to your travel',
            },
            pick_departure_stop: 'Pick departure stop',
            pick_arrival_stop: 'Pick arrival stop',
            change_stop: 'Change stop',
            destination_airport: 'Destination airport',

            confirmation: {
                header: 'The order has been accepted.',
                details: 'Order details will be sent to your e-mail address.',
            },
            purchaser_age: 'Purchaser age',
            stop: 'Stop',
            options_info: 'Picked options are not included in ticket price. Additional fee may be collected by the driver.',
            phone_length_error: 'Wrong length of the phone number',
            zip_length_error: 'Incorrect postcode length (minimum 4 characters)',
            email_validation: 'E-mail is invalid',

            summary: {
                consents_text: 'The reservation is considered made after paying for it and receiving confirmation by e-mail. In the absence of confirmation, please contact us.',
            },

            addresses: {
                ticket_type: 'Ticket type',
                ticket_types: {
                    normal: 'normal',
                    child: 'children under 4 years',
                },
            },
        },
        errors: {
            no_travels_found: 'There are no travels for selected parameters',
        },
    },

    tours: {
        header: 'Tour booking',
        date_from: 'Date from',
        date_to: 'Date to',
        email: 'Your email address',
        message_content: 'Message content',
        name: 'Firstname and lastname',
        phone: 'Phone number',
        submit: 'Submit',
        form_sent: 'Your request has been sent',
        adults_count: 'Number of adults',
        person_count: 'Number of people',
        children_count: 'Number of children',
    },

    berbus: {
        components: {
            search_form: {
                enter_address: 'Enter an address',
                search_no_results: 'No results',
            },

            cart: {
                passenger_types: {
                    adult: 'Adults',
                    child_age_3: 'Children age 3 or under',
                },
            },
            stopInfo: {
                title: 'Where is BERBUS stop?',
                p1: 'BERBUS stops right in front of the exit from the T-1 terminal at the glass shelters located on the arrivals level.',
                p2: 'This is where the BERBUS minivan waits for travelers heading towards Szczecin.',
            },
        },
        pages: {
            address: {
                header: 'Additional information required',

                address_from: 'Adres from',
                address_to: 'Adres to',

                go_back: 'Go back',
                submit: 'Proceed to vehicle selection',

                errors: {
                    invalid_search_param: 'Invalid search parameters.',
                    invalid_passengers_adult: 'Invalid amount of passengers.',
                    no_addresses: 'No address has been found.',
                    incomplete_start_address: 'Fill the missing "from" address fields.',
                    incomplete_end_address: 'Fill the missing "to" address fields.',
                    start_zone_not_found: 'No travels found from the provided "from" address.',
                    end_zone_not_found: 'No travels found from the provided "to" address.',
                    geo_response_error: 'An error has occured while searching for the provided address, please try again later.',
                },
            },

            vehicle: {
                price_per_person: '/ person',
                description: 'Travel at a very good price straight from home! A solution based on the principle of ridesharing, where we connect people traveling in the same direction at the same time. After combining all passengers and the day before the trip, Follow me! provides the final pick-up time from the specified address.',
            },

            passengers: {
                flight_time: 'Flight departure/arrival time',
                flight_time_from: 'Flight departure time from',
                flight_time_to: 'Flight arrival time to',

                submit: 'Proceed to additional options',
            },
        },
    },

    orders: {
        title: 'My Orders',
        status: 'Status',
        departure_date: 'Departure date',
        route: 'Route',
        return_departure_date: 'Return departure date',
        return_route: 'Return route',
        actions: 'Actions',
        details: 'Details',
        no_orders: 'No orders found',
        consents: 'Consents',
        flight: 'Flight',
        components: {
            OrderStatusBadge: {
                created: 'In verification',
                deferred_payment: 'Deferred payment',
                paid_auto: 'Paid (auto)',
                paid_manual: 'Paid (manual)',
                completed: 'Completed',
                canceled_client: 'Canceled - rejected by client',
                canceled: 'Canceled - order issue',
                payment_rejected: 'Rejected - payment',
                to_confirm: 'Reservation to be confirmed',
                canceled_fm: 'Canceled - rejected by Fm!',
                NOT_MERGED: 'Not merged',
                MERGED: 'Merged',
                PLANNED: 'Planned',
                ACCEPTED: 'Accepted',
                IN_PROGRESS: 'In progress',
                COMPLETED: 'Completed',
                CANCELLED: 'Cancelled',
                CANCELLED_BY_CLIENT: 'Cancelled by client',
                REQUEST_FOR_QUOTATION: 'Request for quotation',
                CONFIRMATION: 'Confirmation',
                REALIZATION: 'Realization',
                WAITING_FOR_PAYMENT: 'Waiting for Payment',
                REJECTED_NO_PAYMENT: 'Rejected - No Payment',
                HISTORICAL: 'Historical',
            },
            PaymentStatusBadge: {
                pending: 'Pending',
                paid: 'Paid',
                rejected: 'Rejected',
                error: 'Error',
                MISSING: 'Missing',
                IN_PROGRESS: 'In Progress',
                PAID: 'Paid',
                PARTIALLY_PAID: 'Partially Paid',
            },
        },
        bt: {
            title: 'My Business Taxi orders',
            my_orders: 'My BT orders',
        },
        fat: {
            title: 'My Smart Taxi orders',
            my_orders: 'My Smart Taxi orders',
        },
        berbus: {
            title: 'My BERBUS orders',
            my_orders: 'My BERBUS orders',
        },
        show: {
            title: 'Order details',
            return_to_list: 'Return to order list',
            stops: 'Stops',
            id: 'ID',
            order_details: 'Order details',
            start_place: 'From',
            end_place: 'To',
            return_info: 'Return details',
            return_start_place: 'Return from',
            return_end_place: 'Return to',
            no_return: 'No return route',
            purchaser_info: 'Purchaser info',
            purchaser_full_name: 'Full name',
            purchaser_email: 'E-mail address',
            purchaser_phone: 'Phone number',
            comment: 'Comment',
            no_comment: 'No comment',
            order_values: 'Order values',
            value_name: 'Value name',
            net_value: 'Net price',
            gross_value: 'Gross price',
            vat_value: 'VAT price',
            base_value: 'Base value (before discount)',
            discount_value: 'Discount value',
            user_discount_value: 'User\'s discount value',
            value: 'Total value (after discount)',
            pln_value: 'Amount [PLN]',
            payment_details: 'Payment details',
            return: 'Return',
            invoice: {
                info: 'Invoice data',
                download_invoice: 'Download invoice',
                company: 'Company name',
                vat_number: 'VAT number',
                email: 'E-mail address',
                address: 'Address',
                zip: 'Postal code',
                city: 'City',
                country: 'Country',
            },
            payments: {
                status: 'Payment status',
                provider: 'Payment provider',
                amount: 'Amount',
                amount_pln: 'Amount [PLN]',
                no_payments_found: 'No payments registered',
            },
            passengers: {
                info: 'Passengers details',
                full_name: 'Full name',
                phone: 'Phone number',
                no_passengers: 'No passengers set',
            },
            additional_options: {
                info: 'Additional options',
                name: 'Option',
                quantity: 'Quantity',
            },
            travel_option: {
                cradle_0_13_kg: 'Cradle (0-13 kg)',
                child_seat_9_18_kg: 'Child seat (9-18 kg)',
                child_seat_15_25_kg: 'Child seat (15-25 kg)',
                booster_seat_22_36_kg: 'Booster seat (22-36 kg)',
                skiing_equipment: 'Skiing equipment',
                bike: 'Bike',
                stroller: 'Stroller',
                musical_equipment: 'Musical equipment',
                large_suitcase_15_32_kg: 'Large suitcase (15-32 kg)',
                no_travel_options: 'No additional options',
            },
            payment_providers: {
                CASH: 'Cash',
                CARD: 'Card',
                FAST_TRANSFER: 'Fast transfer',
                TRADITIONAL_TRANSFER: 'Traditional transfer',
                ADVANCE: 'Advance',
                CASH_DRIVER: 'Cash with driver',
                CARD_DRIVER: 'Card with driver',
                TRANSFER: 'Transfer',
            },
        },
    },
    coaches: {
        one_way: 'One way?',
        first_header: 'Fill out the form and check our prices.',
        second_header: 'Sending an inquiry is not binding.',

        transfer_types: {
            pick_type: 'Chose a transfer type',
            additional_options: 'Pick additional options',
            types: {
                sport: 'Sport trip',
                school: 'School trip',
                business: 'Business trip',
                tourist: 'Tourist trip',
                event: 'Event trip',
                other: 'Other',
                other_specify: 'Describe the type of trip',
            },
        },
        additional_options: {
            title: 'Additional options',
            child_seats: 'Child seats',
            sport_equipment: 'Sport equipment',
            music_equipment: 'Music equipment',
            notes: 'Notes',
            labels: {
                quantity: 'Quantity',
                type: 'Type',
            },
        },
        contact_data: {
            header: 'Contact data',

            name: 'Name',
            company_name: 'Company name',
            address: 'Address',
            post_code: 'Post code',
            city: 'City',
            country: 'Country',
            tax_number: 'Tax number',
            phone_number: 'Phone number',
            email: 'E-mail',
            create_account: 'Create an account',
            email_invalid: 'Please fill correct e-mail',
        },
        summary: {
            basic_information: 'Basic information',
            transfer_type: 'Transfer type',
            additional_options: 'Additional options',
            contact_data: 'Contact data',
            agreements: {
                header: 'Agreements',

                rodo: 'Rodo',
                marketing: 'Marketing',
                data_processing: 'Data processing',
                mailing: 'Mailing',
            },
            order_created: 'The order has been correctly registered. All information will be sent by e-mail.',
            submit: 'Send',
        },
    },

    btm: {
        basic_information: 'Basic information',
        one_way: 'One way',
        comment: 'Comment',

        date_pick: 'Pick a date',
        time_pick: 'Pick a time',

        from: 'Departure from',
        to: 'Arrival to',

        travel_options: {
            base_options: 'Basic options',
            additional_options: 'Additional options',
            header: 'Type of journey',

            plane: {
                is_plane_ticket_needed: 'I need a flight ticket',
                regular: 'Regular Airlines',
                low_cost: 'Low cost airlines',
                any: 'Any',
            },
            transfer: {
                is_airport_transfer_needed: 'I need an airport transfer',
                bt: 'Business Taxi',
                at: 'Airport Shuttle',
                any: 'Any',
            },
            hotel: {
                is_hotel_needed: 'I need a hotel',
                stars: 'stars',
                best_price: 'Best price',
                best_quality: 'Best quality',
            },
            insurance: {
                is_insurance_needed: 'I need insurance',
            },
            ferry: {
                is_ferry_ticket_needed: 'I need a ferry ticket',
            },
            train: {
                is_train_ticket_needed: 'I need a train ticket',
            },
            coach: {
                is_coach_ticket_needed: 'I need a coach ticket',
            },
            formal_assistance: {
                is_formal_assistance_needed: 'I need formal help (e.g. visa)',
            },
            event_assistance: {
                is_event_needed: 'I need to organize an event',
            },
        },

        fields: {
            plane_option: 'Plane Option',
            transfer_option: 'Airport Transfer',
            hotel_stars: 'Hotel Standard (stars)',
            hotel_preference: 'Hotel Preference',
            ferry_start_place: 'Ferry From',
            ferry_end_place: 'Ferry To',
            train_start_place: 'Train From',
            train_end_place: 'Train To',
            coach_start_place: 'Coach From',
            coach_end_place: 'Coach To',
        },

        summary: {
            travel_options: 'Basic and additional options',
            order_created: 'The order has been correctly registered. All information will be sent by e-mail.',
            consents_text: '',
        },
    },

    consents: {
        'mark_all': 'Select all of the following',
    },

    validation: {
        iam: {
            user: {
                email_not_unique: 'This e-mail address is already in use',
                login_is_invited: 'The account is inactive, activate your account by entering the activation code from the email message',
                invalid_token_provided: 'The provided activation code is invalid',
                no_pending_invitation: 'The account is already active or has not been registered',
                not_found: 'User not found',
            },
        },
        'at_least_one_passenger_required': 'You must select at least one passenger',
        'passwords_have_to_be_same': 'Password and password confirmation fields have to be the same',
        'unable_to_login':
            'Unable to login. Please check your credentials and try again. If the problem persists, please contact us',
        '4fbb52a8-6945-46b7-b103-a1f4b183082d':
            'The password must be at least 8 characters long and contain at least one uppercase letter, one lowercase letter, one digit and one special character',
        '4b6f5c76-22b4-409d-af16-fbe823ba9332': 'The value must be exactly 6 characters long',
        orders: {
            client: {
                business_require_name: 'The company name field is required',
                business_require_nip: 'The NIP field is required',
            },
            order: {
                invalid_ride_type: 'Invalid ride type',
                ride_type_is_deactivated: 'Ride type is deactivated',
                order_requires_min_one_passenger: 'Order requires at least one passenger',
                order_requires_min_one_ride: 'Order requires at least one ride',
                cyclic_start_must_be_earlier_than_end: 'Cyclic start date must be earlier than end date',
                no_available_rides_cyclic_found: 'No available rides found in the cyclic date range',
                order_cannot_be_created_in_short_time: 'Too short time until departure – booking is possible at least 48 hours before the start of the journey',
                order_requires_only_adult_passengers: 'Order requires only adult passengers',
                order_requires_only_child_above_4_passengers: 'Order requires only children above 4 years old',
                order_requires_ride_character: 'Ride type requires character, but data not provided',
                order_ride_stop_point_requires_date: 'Stop point requires a date',
                order_ride_requires_exactly_two_stops: 'Ride requires exactly two stops, but an invalid amount was given',
                order_ride_requires_at_least_two_stops: 'Ride requires at least two stops, but an invalid amount was given',
                first_or_last_stop_point_must_have_date: 'First or last stop point must have a date',
                fmts_stop_points_dates_must_be_at_correct_time: 'Follow Me To School ride has stop points at incorrect times',
                order_ride_requires_flight_number: 'Ride requires flight number, but data not provided',
                order_ride_requires_flight_date: 'Ride requires flight date, but data not provided',
                order_ride_requires_vehicle_preferred: 'Ride requires preferred vehicle, but data not provided',
                order_ride_vehicle_preferred_not_exists: 'Given preferred vehicle does not exist',
                additional_option_not_exists: 'Given additional option does not exist',
                additional_option_not_active: 'Given additional option is not active',
                voucher_not_exists: 'Given voucher does not exist',
                voucher_is_not_available: 'Given voucher is not available',
                voucher_cannot_be_used: 'Given voucher cannot be used',
                first_passenger_requires_personal_data: 'First passenger personal data not provided',
            },
            voucher: {
                voucher_not_exists: 'The given voucher does not exist',
                voucher_is_not_available: 'The given voucher is not available',
                voucher_cannot_be_used: 'The given voucher cannot be used',
            },
        },
    },
};
